export default "/fonts/hotelspace.eot?9ec80ebe496ce27af94bfec01091a9a7";